"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var Select = function (_a) {
    var options = _a.options, name = _a.name, onChange = _a.onChange, selected = _a.selected, props = __rest(_a, ["options", "name", "onChange", "selected"]);
    var handleOnChange = function (event) {
        var select = event.currentTarget;
        if (onChange) {
            onChange(select.value);
        }
    };
    return (0, jsx_runtime_1.jsxs)("div", __assign({}, props, { children: [(0, jsx_runtime_1.jsx)("select", __assign({ onChange: handleOnChange, class: "w-full font-semibold text-black cursor-pointer appearance-none rounded-lg bg-transparent border border-solid border-purple px-4 py-2 pr-10 text-sm focus:border-purple-darker focus:outline-none sm:px-5 sm:py-3 sm:pr-9 sm:text-base", name: name }, { children: options.map(function (option) {
                    return (0, jsx_runtime_1.jsx)("option", __assign({ selected: !!selected && option.value === selected, value: option.value }, { children: option.name }));
                }) })), (0, jsx_runtime_1.jsx)("div", __assign({ class: "pointer-events-none text-purple-darker absolute inset-y-0 right-4 flex items-center" }, { children: (0, jsx_runtime_1.jsx)("svg", __assign({ class: "h-4 w-4 sm:h-5 sm:w-5", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", viewBox: "0 0 24 24", stroke: "currentColor" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M19 9l-7 7-7-7" }) })) }))] }));
};
exports.default = Select;
